import { render, staticRenderFns } from "./AddressAutoComplete.vue?vue&type=template&id=a84e5906"
import script from "./AddressAutoComplete.vue?vue&type=script&lang=js"
export * from "./AddressAutoComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports